import './bootstrap';

import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import Layout from './Layouts/Layout.vue';
import VSelectWithPopper from '@/Components/VSelectWithPopper.vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import dateTimeMixin from './mixins/dateTimeMixin';
import minutesToHoursMixin from './mixins/minutesToHoursMixin';
import pageDateInputMixin from './mixins/pageDateInputMixin';
import currencyMixin from './mixins/currencyMixin';
import modalDragMixin from './mixins/modalDragMixin';
import { GoogleMapsMixin } from './mixins/GoogleMapsMixin.js';
import { createI18n } from 'vue-i18n';
import ConfirmationModal from '@/Components/ConfirmationModal.vue';
import messages from './vue-i18n-locales.generated'; // generato da `php artisan vue-i18n:generate`
import Loader from '@/Components/Loader.vue';
import { useLoader } from './Composables/useLoader.js'; // Aggiungi questa riga
import VueDraggableResizable from 'vue-draggable-resizable'
import usePolicies from './Composables/usePolicies';
const { isLoading, loadingText, showLoader, hideLoader, withLoader, withLoaderSafe, withInertiaLoader } = useLoader();
import MagoEnums from './enums';

// Vuetify - Importato prima di Tailwind
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

// Tailwind CSS - Importato dopo Vuetify per avere precedenza
import '../css/app.css';
// Inserire ogni componente utilizzato qui e nell'elenco subito sotto
import { VDataTable, VDataTableServer, VTreeview, VSwitch, VTextField, VTextarea, VMenu } from 'vuetify/components'

import { it , en , fr } from 'vuetify/locale'
import usePermissions from './Composables/usePermissions';



import { OhVueIcon, addIcons } from "oh-vue-icons";
import {
    LaUsersSolid,
    HiSolidDocumentReport,
    FaUsersCog,
    MdBadgeRound,
    LaCertificateSolid,
    RiContactsBookFill,
    OiChecklist,
    BiClockHistory,
    BiFileEarmarkBarGraph,
    FaFileSignature,
    MdManagesearch,
    MdNewlabel,
    PrUsers,
    FaRegularHandshake,
    CoLocationPin,
    CoCalendar,
    MdInventoryRound,
    MdMovetoinboxRound,
    FaTruckLoading,
    MdArrowupward,
    MdArrowdownward,
    MdNavigatenextRound,
    MdNavigatebeforeRound,
    MdFirstpageRound,
    MdLastpageRound,
    MdIndeterminatecheckboxRound,
    MdCheckboxRound,
    MdCheckboxoutlineblankRound,
    MdRemovecircleoutlineRound,
    MdRemovecircleRound,
    MdWarehouseRound,
    MdFactcheckOutlined,
    MdAutorenew,
    CoCopy,
    HiArrowsExpand,
    BiCartCheckFill,
    CoPrint,
    BiListUl,
    BiListCheck,
    BiTools,
    LaFileInvoiceSolid,
    BiInfoCircle,
    MdDashboardRound,
    MdMobilescreenshare,
    OiPackage,
    MdTableview,
    BiPencil,
    CoTruck,
    PxAnalytics,
    MdBallotOutlined,
    HiSolidDownload,
    CoX,
    CoPlus,
    CoMap,
    CoSearch,
    HiRefresh, 
    HiChevronUp,
    HiChevronDown,
    HiMail,
    MdModeoftravelRound,   
    FaMapMarked,
    HiAnnotation,
    HiLightningBolt,
    CoTrash,
    HiAdjustments,
    BiQrCodeScan,
    GiForklift,
    FaEdit,
    FaTrash,
    FaBusinessTime,
    HiSwitchHorizontal,
    HiPlus,
    BiDownload,
    FaEye,
    FaKeyboard,
    BiGit,
    MdComparearrows,
    MdKeyboardarrowdownRound,
    MdKeyboardarrowupRound,
    RiFileExcel2Line,
    MdLanguageRound,
    FaLock,
    RiMoneyEuroCircleLine,
    LaFileInvoiceDollarSolid,  
    BiCalendar3,
    BiBarChartSteps,
    BiDiagram3,
    HiSolidUserGroup,
    HiSolidCog,
    HiSolidCollection,
    HiSolidCheckCircle,
    HiSolidUsers,
    HiSolidStar,
    HiSolidPencil,
    HiSolidXCircle,
    HiSolidUserAdd,
    HiSolidUserRemove,
    HiSolidShieldCheck,
    HiSolidArrowCircleLeft,
    HiSolidExclamationCircle,
    HiSolidScissors,
    HiSolidBell,
    HiSolidInformationCircle,
    BiCalendarEvent,
    BiCalendar2Plus,
    BiArrowCounterclockwise,
    MdLocalshippingTwotone,
    BiPencilSquare,
    HiClock,
    GiCargoCrate,
    LaBarcodeSolid,
    MdMoretime,
    MdViewtimelineOutlined,
    FaSolarPanel,
    MdFactory,
    MdPrecisionmanufacturingRound,
    BiFileEarmarkPost,
    MdFindinpageOutlined,
    BiPaintBucket,
    FaDolly,
    AiInspire,
    IoScanCircleOutline,
    OiCodescanCheckmark
} from "oh-vue-icons/icons";

addIcons(
    LaUsersSolid,
    HiSolidDocumentReport,
    FaUsersCog,
    MdBadgeRound,
    LaCertificateSolid,
    RiContactsBookFill,
    OiChecklist,
    BiClockHistory,
    BiFileEarmarkBarGraph,
    FaFileSignature,
    MdManagesearch,
    MdNewlabel,
    PrUsers,
    FaRegularHandshake,
    CoLocationPin,
    CoCalendar,
    MdInventoryRound,
    MdMovetoinboxRound,
    FaTruckLoading,
    MdArrowupward,
    MdArrowdownward,
    MdNavigatenextRound,
    MdNavigatebeforeRound,
    MdFirstpageRound,
    MdLastpageRound,
    MdIndeterminatecheckboxRound,
    MdCheckboxRound,
    MdCheckboxoutlineblankRound,
    MdRemovecircleoutlineRound,
    MdRemovecircleRound,
    MdWarehouseRound,
    MdFactcheckOutlined,
    MdAutorenew,
    CoCopy,
    HiArrowsExpand,
    BiCartCheckFill,
    CoPrint,
    BiListUl,
    BiListCheck,
    BiTools,
    LaFileInvoiceSolid,
    BiInfoCircle,
    MdDashboardRound,
    MdMobilescreenshare,
    OiPackage,
    MdTableview,
    BiPencil,
    CoTruck,
    PxAnalytics,
    MdBallotOutlined,
    HiSolidDownload,
    CoX,
    CoPlus, 
    CoMap,
    CoSearch,
    CoTrash,
    HiRefresh, 
    HiChevronUp,
    HiChevronDown,
    HiMail,
    MdModeoftravelRound,   
    FaMapMarked,
    HiAnnotation,
    HiLightningBolt,
    HiAdjustments,
    BiQrCodeScan,
    GiForklift,
    FaEdit,
    FaTrash,
    FaBusinessTime,
    HiSwitchHorizontal,
    HiPlus,
    BiDownload,
    FaEye,
    FaKeyboard,
    BiGit,
    MdComparearrows,
    MdKeyboardarrowdownRound,
    MdKeyboardarrowupRound,
    RiFileExcel2Line,
    MdLanguageRound,
    FaLock,
    RiMoneyEuroCircleLine,
    LaFileInvoiceDollarSolid,
    BiCalendar3,
    BiBarChartSteps,
    BiDiagram3,
    HiSolidUserGroup,
    HiSolidCog,
    HiSolidCollection,
    HiSolidCheckCircle,
    HiSolidUsers,
    HiSolidStar,
    HiSolidPencil,
    HiSolidXCircle,
    HiSolidUserAdd,
    HiSolidUserRemove,
    HiSolidShieldCheck,
    HiSolidArrowCircleLeft,
    HiSolidExclamationCircle,
    HiSolidScissors,
    HiSolidBell,
    HiSolidInformationCircle,
    BiCalendarEvent,
    BiCalendar2Plus,
    BiArrowCounterclockwise,
    MdLocalshippingTwotone,
    BiPencilSquare,
    HiClock,
    GiCargoCrate,
    LaBarcodeSolid,
    MdMoretime,
    MdViewtimelineOutlined,
    FaSolarPanel,
    MdFactory,
    MdPrecisionmanufacturingRound,
    BiFileEarmarkPost,
    MdFindinpageOutlined,
    BiPaintBucket,
    FaDolly,
    AiInspire,
    IoScanCircleOutline,
    OiCodescanCheckmark
);

const appName = import.meta.env.VITE_APP_NAME || 'Page93 - Portale';

createInertiaApp({
    title: (title) => title ? `${title} - ${appName}` : appName,
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.vue', { eager: true })
        let page = pages[`./Pages/${name}.vue`]
        if (page.default.layout === undefined) page.default.layout = Layout
        return page
    },
    setup({ el, App, props, plugin }) {

        const locale = props.initialPage.props.locale || 'it';
        const customerTranslations = props.initialPage.props.customer_translations || {};

        const deepMerge = (target, source) => {
            for (const [key, value] of Object.entries(source)) {
                if (value && typeof value === 'object' && !Array.isArray(value) && target[key] && typeof target[key] === 'object' && !Array.isArray(target[key])) {
                    target[key] = deepMerge(target[key], value);
                } else {
                    target[key] = value;
                }
            }
            return target;
        };

        const mergeCustomerTranslations = (loc, ct) => {
            const defaultMsg = JSON.parse(JSON.stringify(messages[loc] || {}));
            return deepMerge(defaultMsg, ct);
        };
        
        const vuetify = createVuetify({
            components: {
                VDataTable,
                VDataTableServer,
                VTreeview,
                VSwitch,
                VTextField,
                VTextarea,
                VMenu,
            },
            locale: {
                locale,
                fallback: 'it',
                messages: {
                    it: { ...it, dataTable: { ...it.dataTable, sortBy: '⇅ Ordina per' } },
                    en: { ...en, dataTable: { ...en.dataTable, sortBy: '⇅ Sort by' } },
                    fr: { ...fr, dataTable: { ...fr.dataTable, sortBy: '⇅ Trier par' } },
                },
            },
            theme: {
                options: {
                    customProperties: true,
                },
            },
            defaults: {
                // Configurazioni per evitare conflitti con Tailwind
                global: {
                    ripple: false, // Disabilita ripple se causa problemi
                },
                VBtn: {
                    style: 'text-transform: none;', // Previene override di text-transform
                },
                VTextField: {
                    variant: 'outlined',
                },
            },
        })

        const mergedMessages = {
            ...messages,
            [locale]: mergeCustomerTranslations(locale, customerTranslations),
        };           
        const i18n = createI18n({
            legacy: false,
            globalInjection: true,
            locale: locale,
            fallbackLocale: 'it',
            messages: mergedMessages,
        });

        const app = createApp({ render: () => h(App, props) })
            .component("v-icon", OhVueIcon)
            .component("v-select", VSelectWithPopper)
            .component("ConfirmationModal", ConfirmationModal)
            .component('VueDatePicker', VueDatePicker)
            .component('Loader', Loader)
            .component("vue-draggable-resizable", VueDraggableResizable)
            .use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .use(MagoEnums)
            .mixin({
                data(){
                    if (this.loadingText === undefined) {
                        return {
                            isLoading : isLoading,
                            loadingText : loadingText
                        };
                    }
                    else return {};
                }
            })
            .mixin(dateTimeMixin)
            .mixin(minutesToHoursMixin)
            .mixin(currencyMixin)
            .mixin(modalDragMixin)
            .mixin(GoogleMapsMixin)
            .mixin(pageDateInputMixin);

        app.use(i18n);

        const applyCustomerTranslations = (pageProps) => {
            const ct = pageProps?.customer_translations || {};
            const loc = pageProps?.locale || locale;
            i18n.global.setLocaleMessage(loc, mergeCustomerTranslations(loc, ct));
            if (i18n.global.locale.value !== loc) {
                i18n.global.locale.value = loc;
            }
        };
        router.on('success', (event) => {
            applyCustomerTranslations(event.detail.page.props);
        });
            
        const { can, hasRole } = usePermissions();
        app.config.globalProperties.$can = can;
        app.config.globalProperties.$hasRole = hasRole;

        // Inietta come globalProperties per accesso diretto in tutti i componenti
        app.config.globalProperties.showLoader = showLoader;
        app.config.globalProperties.hideLoader = hideLoader;
        app.config.globalProperties.withLoader = withLoader;
        app.config.globalProperties.withLoaderSafe = withLoaderSafe;
        app.config.globalProperties.withInertiaLoader = withInertiaLoader;

        const { policy } = usePolicies();
        app.config.globalProperties.$policy = policy;

        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
